module.exports = __webpack_public_path__ + "static/logo-454b82844c017caea2bc11911a63f9b0.png";